import { useEffect, Fragment, ReactNode } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  VerificationPageRoute,
  AspspSelectPageRoute,
  SmartFlowPageRoute,
  verificationIdParam,
  frontendTypeParam,
} from 'src/routes';
import { StatusRouteMap } from 'src/common/components/RequireCorrectStep/StatusRouteMap';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { useStatusOfVerificationProcessQuery } from 'src/common/components/RequireCorrectStep/useProcessStatusQuery';
import { useFrontendTypeParam } from '../../hooks/useFrontendType';
import { environment } from 'src/config/environment';
import { VerificationStatus } from 'src/common/models/verificationModels';
import { FlowType } from 'src/common/models/processModels';

export const RequireCorrectStep = ({ children }: { children: ReactNode }) => {
  const history = useHistory();
  const location = useLocation();
  const verificationId = useVerificationId();
  const frontType = useFrontendTypeParam();

  const status = useStatusOfVerificationProcessQuery(verificationId);
  useEffect(() => {
    if (status.data) {
      // Web SDK: stay on AspspSelectPage when bank is selected or business consent granted (WebSocket may have updated before REST).
      if (
        environment.isWebSdk &&
        location.pathname === AspspSelectPageRoute &&
        [
          VerificationStatus.BusinessConsentGranted,
        ].includes(status.data.verificationStatus)
      ) {
        return;
      }

      if (status.data.verificationFlow === FlowType.SmarFlow) {
        if (location.pathname !== SmartFlowPageRoute) {
          history.replace({
            pathname: SmartFlowPageRoute,
            search: frontType
              ? `?${verificationIdParam}=${verificationId}&${frontendTypeParam}=${frontType}`
              : `?${verificationIdParam}=${verificationId}`,
          });
        }
        return;
      }

      const statusRoute = StatusRouteMap.get(status.data.verificationStatus);

      if (statusRoute && location.pathname !== statusRoute) {
        if (statusRoute === VerificationPageRoute) {
          history.replace(VerificationPageRoute);
        } else {
          history.replace({
            pathname: statusRoute,
            search: frontType ? `?${verificationIdParam}=${verificationId}&${frontendTypeParam}=${frontType}` : `?${verificationIdParam}=${verificationId}`,
          });
        }
      }
    }
  }, [status.data, location.pathname]);

  return <Fragment>{children}</Fragment>;
};
